"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _framerMotion = require("framer-motion");
var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));
var _head = _interopRequireDefault(require("lodash/fp/head"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _logDeprecatedWarnings = _interopRequireDefault(require("../../utils/logDeprecatedWarnings"));
var _useAfterMount = _interopRequireDefault(require("../../useAfterMount"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var warningProps = [{
  prop: 'in',
  replacement: 'show'
}, {
  prop: 'timeout',
  replacement: 'duration'
}, {
  prop: 'appear',
  replacement: 'initial'
}];
var animations = {
  fromLeft: {
    initial: {
      x: -10,
      y: 0,
      opacity: 0
    },
    animate: {
      x: 0,
      y: 0,
      opacity: 1
    },
    exit: {
      x: -10,
      y: 0,
      opacity: 0
    }
  },
  fromRight: {
    initial: {
      x: 10,
      y: 0,
      opacity: 0
    },
    animate: {
      x: 0,
      y: 0,
      opacity: 1
    },
    exit: {
      x: 10,
      y: 0,
      opacity: 0
    }
  },
  fromTop: {
    initial: {
      y: -10,
      x: 0,
      opacity: 0
    },
    animate: {
      y: 0,
      x: 0,
      opacity: 1
    },
    exit: {
      y: -10,
      x: 0,
      opacity: 0
    }
  },
  fromBottom: {
    initial: {
      y: 10,
      x: 0,
      opacity: 0
    },
    animate: {
      y: 0,
      x: 0,
      opacity: 1
    },
    exit: {
      y: 10,
      x: 0,
      opacity: 0
    }
  },
  fade: {
    initial: {
      x: 0,
      y: 0,
      opacity: 0
    },
    animate: {
      x: 0,
      y: 0,
      opacity: 1
    },
    exit: {
      x: 0,
      y: 0,
      opacity: 0
    }
  },
  tabs: {
    initial: {
      x: 2,
      y: 0,
      opacity: 0
    },
    animate: {
      x: 0,
      y: 0,
      opacity: 1
    },
    exit: {
      x: -2,
      y: 0,
      opacity: 0
    }
  },
  page: {
    initial: 'pageEnter',
    animate: 'pageCenter',
    exit: 'pageExit'
  },
  pageBack: {
    initial: 'pageEnter',
    animate: 'pageCenter',
    exit: 'pageExit'
  }
};
var pageTransitionVariants = {
  pageEnter: function pageEnter(pageDirection) {
    return {
      x: pageDirection > 0 ? '60%' : '-60%',
      opacity: 0
    };
  },
  pageCenter: {
    x: 0,
    opacity: 1
  },
  pageExit: function pageExit(pageDirection) {
    return {
      zIndex: 0,
      x: pageDirection < 0 ? '60%' : '-60%',
      opacity: 0
    };
  }
};
var getPageDirection = function getPageDirection(animationStyle) {
  switch (animationStyle) {
    case Fade.PAGE_BACK:
      return -1;
    default:
      return 1;
  }
};
var Fade = function Fade(props) {
  var oldIn = props["in"],
    timeout = props.timeout,
    appear = props.appear,
    exitBeforeEnter = props.exitBeforeEnter,
    onExitComplete = props.onExitComplete,
    animationStyle = props.animationStyle,
    animatePresenceProps = props.animatePresenceProps,
    motionProps = props.motionProps,
    children = props.children;
  (0, _logDeprecatedWarnings["default"])(warningProps, props, 'Fade');
  var duration = props.duration || timeout;
  if (duration > 10) {
    duration = duration / 100;
  }
  var show = props.show || oldIn;
  var initial = (0, _isNil["default"])(appear) ? props.initial : appear;
  var _useState = (0, _react.useState)(initial),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    allowInitialAnimation = _useState2[0],
    setAllowInitialAnimation = _useState2[1];
  (0, _useAfterMount["default"])(function () {
    if (!allowInitialAnimation) {
      setAllowInitialAnimation(true);
    }
  });
  var motionDivKey = 'fade';

  // If there are multiple children that are conditionally rendered like
  // in case of a tabbed content - get the current visible child key
  // to update the motion.div key to animate different children
  if ((0, _isArray["default"])(children)) {
    var currentChild = (0, _head["default"])(children.filter(function (child) {
      return Boolean(child);
    }));
    motionDivKey = "fade-".concat(currentChild.key);
  }

  // In case the animation is a page transition, use custom variants and add a custom pageDirection variable
  // to animate in the right direction
  var isPageTransition = animationStyle === Fade.PAGE || animationStyle === Fade.PAGE_BACK;
  var pageDirection = getPageDirection(animationStyle);
  var custom = isPageTransition ? pageDirection : null;
  var pageTransitionProps = isPageTransition ? {
    variants: pageTransitionVariants
  } : null;
  var animationProps = _objectSpread({}, animations[animationStyle]);

  // Disable initial animation on mount. After mount the initial animation step is needed to enable
  // the "fade-in" animation, otherwise it just appears
  if (!allowInitialAnimation) {
    animationProps.initial = false;
  }
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, (0, _extends2["default"])({
    initial: allowInitialAnimation,
    exitBeforeEnter: exitBeforeEnter,
    onExitComplete: onExitComplete,
    custom: custom
  }, animatePresenceProps), show && /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, (0, _extends2["default"])({
    key: motionDivKey,
    transition: {
      duration: duration
    },
    custom: custom
  }, animationProps, pageTransitionProps, motionProps), children));
};
Fade.FADE = 'fade';
Fade.FROM_LEFT = 'fromLeft';
Fade.FROM_RIGHT = 'fromRight';
Fade.FROM_TOP = 'fromTop';
Fade.FROM_BOTTOM = 'fromBottom';
Fade.TABS = 'tabs';
Fade.PAGE = 'page';
Fade.PAGE_BACK = 'pageBack';
Fade.defaultProps = {
  // in: false,
  show: true,
  // timeout: 200,
  duration: 0.2,
  // appear: false,
  initial: false,
  exitBeforeEnter: false,
  animationStyle: 'fade'
};
Fade.propTypes = {
  "in": _propTypes["default"].bool,
  // deprecated
  show: _propTypes["default"].bool,
  appear: _propTypes["default"].bool,
  // deprecated
  initial: _propTypes["default"].bool,
  exitBeforeEnter: _propTypes["default"].bool,
  timeout: _propTypes["default"].number,
  // deprecated
  duration: _propTypes["default"].number,
  onEnter: _propTypes["default"].func,
  onEntering: _propTypes["default"].func,
  onEntered: _propTypes["default"].func,
  onExit: _propTypes["default"].func,
  onExiting: _propTypes["default"].func,
  onExited: _propTypes["default"].func,
  onExitComplete: _propTypes["default"].func,
  animationStyle: _propTypes["default"].oneOf(['fromLeft', 'fromRight', 'fromTop', 'fromBottom', 'fade', 'tabs', 'page', 'pageBack']),
  animatePresenceProps: _propTypes["default"].object,
  motionProps: _propTypes["default"].object,
  children: _propTypes["default"].any
};
var _default = Fade;
exports["default"] = _default;